import { render } from "./IconOrSvg.vue?vue&type=template&id=3d2eefae&scoped=true"
import script from "./IconOrSvg.vue?vue&type=script&lang=js"
export * from "./IconOrSvg.vue?vue&type=script&lang=js"

import "./IconOrSvg.vue?vue&type=style&index=0&id=3d2eefae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2eefae"]])

export default __exports__